export default __webpack_public_path__ + "static/media/share_image_video.2d4c0a66.jpg";